import translations from './translations';

export function registerNotificationModule(ctx) {
  ctx.registerTranslations(translations).then();
  return {};
}
